/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const UPDTAEEDUCATION= createAsyncThunk(
  "updateEducation/updateEducation",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updateEducationSlice = createSlice({
  name: "updateEducationSlice",
  initialState: {
    updateEducation: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdateEducation: (state) => {
        state.updateEducation.loading = false
        state.updateEducation.error = false
        state.updateEducation.data = []
        state.updateEducation.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPDTAEEDUCATION.fulfilled, (state, action) => {
      state.updateEducation = {
        ...state.updateEducation,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDTAEEDUCATION.pending, (state, action) => {
      state.updateEducation = {
        ...state.updateEducation,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDTAEEDUCATION.rejected, (state, action) => {
      state.updateEducation = {
        ...state.updateEducation,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updateEducationAction = {
    UPDTAEEDUCATION,
};

export { updateEducationAction };
export default updateEducationSlice.reducer;
export const {setInitialStateOfupdateEducation} = updateEducationSlice.actions